import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "prevButton", "nextButton", "indicator"]
  static values = {
    currentIndex: { type: Number, default: 0 }
  }

  connect() {
    this.showSlide(this.currentIndexValue)
  }

  next() {
    this.currentIndexValue = (this.currentIndexValue + 1) % this.slideTargets.length
    this.showSlide(this.currentIndexValue)
  }

  prev() {
    this.currentIndexValue = (this.currentIndexValue - 1 + this.slideTargets.length) % this.slideTargets.length
    this.showSlide(this.currentIndexValue)
  }

  goToSlide(event) {
    const index = parseInt(event.currentTarget.dataset.index)
    this.currentIndexValue = index
    this.showSlide(this.currentIndexValue)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.remove('hidden')
        slide.classList.add('block')
      } else {
        slide.classList.remove('block')
        slide.classList.add('hidden')
      }
    })

    // Update indicators
    if (this.hasIndicatorTarget) {
      this.indicatorTargets.forEach((indicator, i) => {
        if (i === index) {
          indicator.classList.add('bg-white')
          indicator.classList.remove('bg-white/50')
        } else {
          indicator.classList.add('bg-white/50')
          indicator.classList.remove('bg-white')
        }
      })
    }
  }
}
